import { AUTO_NAVIG_WINDOW_NAME } from "./auto-navig";

// The tab each named wallboard window rests on while no flight is active. Both are
// flow-briefing tabs, so the auto-accept window still creates flights from there.
const IDLE_ROUTES = new Map([
  [AUTO_NAVIG_WINDOW_NAME, "/flow-briefing/webcams"],
  // AUTO_ACCEPT_WINDOW_NAME; a literal, because mission.service is too heavy to import here.
  ["efb-auto-accept", "/flow-briefing/weather"],
]);

/** True in a wallboard window that rests on the weather tab. */
export function isWallboardWeatherWindow(windowName: string): boolean {
  return IDLE_ROUTES.get(windowName) === "/flow-briefing/weather";
}

/** True when the auto-NAVIG window must open NAVIG for a flight that was already
 *  active at its first check. Auto-NAVIG itself opens only a flight that arrives,
 *  so a reload during a flight left the window on the flow briefing. */
export function navigAtLoad(windowName: string, hadFlight: boolean | undefined, hasFlight: boolean): boolean {
  return windowName === AUTO_NAVIG_WINDOW_NAME && hadFlight === undefined && hasFlight;
}

/** The tab the weather window opens when a flight starts, or null: the hybrid
 *  tab, and only from its waiting tab, so a tab an operator opened stays. It
 *  moves at the first check too, for a reload during a flight. */
export function flightRouteFor(
  windowName: string,
  hadFlight: boolean | undefined,
  hasFlight: boolean,
  path: string
): string | null {
  if (!hasFlight || hadFlight === true) return null;
  return isWallboardWeatherWindow(windowName) && path === IDLE_ROUTES.get(windowName)
    ? "/flow-briefing/briefing"
    : null;
}

/** The flight the weather window's hybrid tab must scroll to, or null: the active
 *  flight, once each time it changes. The other wallboard windows show that
 *  flight, and the hybrid tab lists older flights above it. Only while the
 *  window shows the hybrid tab (`path`): nothing else takes the request, so
 *  on another tab it would wait and scroll a later visit to an old flight. */
export function scrollFlightFor(
  windowName: string,
  shown: string | undefined,
  active: string | undefined,
  path: string
): string | null {
  const hybrid = path === "/flow-briefing" || path === "/flow-briefing/briefing";
  return isWallboardWeatherWindow(windowName) && hybrid && active && active !== shown ? active : null;
}

/** The tab to open now, or null. A window moves at its first check (`hadFlight`
 *  undefined) and when its flight ends, so a tab an operator opened later stays. */
export function idleRouteFor(windowName: string, hadFlight: boolean | undefined, hasFlight: boolean): string | null {
  if (hasFlight || hadFlight === false) return null;
  return IDLE_ROUTES.get(windowName) ?? null;
}
